module.exports = __webpack_public_path__ + "static/media/abtest_en.56126274.png";